// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lucario_mega: PokeData = {
  "id": 10059,
  "name": "lucario-mega",
  "height": 13,
  "weight": 575,
  "base_experience": 219,
  "types": [
    PokeType.FIGHTING,
    PokeType.STEEL
  ],
  "api_moves": [
    "swords-dance",
    "counter",
    "quick-attack",
    "foresight",
    "detect",
    "bone-rush",
    "metal-claw",
    "extreme-speed",
    "metal-sound",
    "calm-mind",
    "feint",
    "close-combat",
    "me-first",
    "aura-sphere",
    "dragon-pulse",
    "quick-guard",
    "heal-pulse",
    "work-up",
    "power-up-punch",
    "laser-focus"
  ],
  "moves": [
    "quick-attack",
    "metal-claw",
    "metal-sound",
    "calm-mind",
    "close-combat",
    "dragon-pulse",
    "vacuum-wave",
    "gear-up",
    "drain-punch",
    "metal-rush",
    "bulk-up",
    "jump-kick",
    "magnet-pull"
  ],
  "evolution_chain": {
    "id": 232,
    "item": null,
    "species": [
      {
        "name": "riolu",
        "order": 467,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lucario",
        "order": 468,
        "types": [
          PokeType.FIGHTING,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 447,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 90,
    "speed": 135,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
